let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7dkWW"), load("6rpul")]).then(() => parcelRequire('2ZkUh'));